export interface IReleases {
  uuid?: string;
  product_name: string;
  release_version: string;
  overview: string;
  impacts: string;
  issue_summary: string;
  note: string;
  link: string;
}


export const ReleasesInitValues: IReleases = {
  product_name: '',
  release_version: '',
  overview: '',
  impacts: '',
  issue_summary: '',
  note: '',
  link: '',

}

